import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { memo } from 'react';
const CheckboxFC = ({ name, label, checked, indeterminate, isDisabled, sx, onChange }) => {
    return (_jsx(ChakraCheckbox, { size: "md", name: name, checked: checked, isIndeterminate: indeterminate, defaultChecked: checked, isDisabled: isDisabled, onChange: (event) => onChange(event.target.checked), sx: sx, children: label }, `${checked}`));
};
export const Checkbox = memo(CheckboxFC);
//# sourceMappingURL=Checkbox.js.map